module.exports = __webpack_public_path__ + "assets/img/consideration-GED-est-elle-solution.dcdf6c44.jpg";